<div class="footer" *transloco="let t">
  <div class="footer__title"> © Consileon Business Consultancy GmbH <a rel="noopener"
      href="https://www.consileon.de">www.consileon.de</a></div>
  <div class="footer__links">
    <a rel="noopener" href="https://www.consileon.de/impressum">{{ t('footer.imprint') }}</a>
    <a rel="noopener" href="https://www.consileon.de/datenschutz">{{ t('footer.privacy') }}</a></div>
</div>
